import React, { useState, Fragment, useContext, useRef } from 'react';
import Image from 'next/image';
import { FaCaretDown } from "react-icons/fa";
import { s3Static } from "../../utils/constants";
import { UserContext } from '../../context/UserContext';
import { HiBell, HiHome } from "react-icons/hi";
import { FaChevronLeft } from 'react-icons/fa'
import { Menu, MenuButton, MenuItem, MenuItems, Transition  } from '@headlessui/react';
import { logout } from '../../api/user/logout-api';
import { useRouter } from 'next/router';
import { SystemError } from '../error/SystemError';
import { chatWs, getChatWs, getStatusWs, statusWs } from '../../service/ws-service';
import { LoadingCover } from './LoadingCover';

export const HomeNav = () => {  
    const router = useRouter();    

    let logoButton = useRef(false)

    const [ isLoading, setIsLoading ] = useState(false)
    const [ isSystemError, setIsSystemError ] = useState(false);
    const [ errorContent, setErrorContent ]  = useState({'header': "", 'body': ""}); 
    
    const { userId, handleName, userFirstName, userProfilePicture, notificationCount, userAccountType, appType, businessType, userServiceCategory } = useContext(UserContext);    
    
    if(router.pathname === "/home" 
        || router.pathname === "/home/requests" 
        || router.pathname === "/home/buzz"
        || router.pathname.includes("/make-payment/job/")
        || router.pathname.includes("/booking/")
        ){
        logoButton = true
    } else {
        logoButton = false
    }

    const logoutUser = async () => {
        try {
            setIsLoading(true);
            if(typeof statusWs != "undefined" && getStatusWs().readyState != 3){
                statusWs.close(1000, "user left");
            }
            if(typeof chatWs != "undefined" && getChatWs().readyState != 3){
                chatWs.close(1000, "user left");
            }

            let logoutResponse = await logout();

            if(appType != "web"){
                globalThis.location.href = '/app'
                return 
            }
            setIsLoading(false);
            if(logoutResponse.logout == true){        		
                globalThis.location.href = '/signin'
        	}
        } catch (error) {
            console.log(error);
            setIsLoading(false);
            setErrorContent({'header': "Logout Error", 'body': "Please try again. If problem persists, contact us at support@stringssg.com"});
            setIsSystemError(true);
        }
    }
    
    const changeRoute = (path) =>{
        // setIsLoading(true)
        router.push(path).then((response) => {
            setIsLoading(false)
        })
    }
    
    const reload = () => {
        router.reload("/home")
    }

  return (
      <section className="h-12 relative">
          <nav className="fixed top-0 right-0 left-0 z-20 transition-all duration-100 bg-white border-b-2 border-b-amber-400">
            <div className="max-w-6xl mx-auto px-2 sm:px-6 lg:px-8">
                <div className="relative flex items-center justify-between h-12">
                    <div className="absolute inset-y-0 right-0 flex items-center md:hidden">
                        {/* <div onClick={() => changeRoute('/home')} className='cursor-pointer'>
                            <span className="mr-5 outline-none bg-transparent text-orange-600 hover:text-orange-500 flex">
                                <HiHome className='text-3xl'/>
                            </span>
                        </div>
                        <div className='flex cursor-pointer' onClick={() => changeRoute('/notification')}>
                            <div className='flex items-center mr-5'>                                                                
                                <span className="outline-none bg-transparent text-orange-600 hover:text-orange-500 flex">
                                    <HiBell className='text-3xl'/>
                                </span>
                                {notificationCount > 0 &&
                                    <>
                                        {notificationCount > 20 ?
                                            <span className='bg-red-600 text-white px-1 rounded-full text-xs -mt-5 -ml-5'>
                                               20+
                                            </span>
                                        :
                                            <span className='bg-red-600 text-white px-1 rounded-full text-xs -mt-5 -ml-3'>
                                                {notificationCount}
                                            </span>
                                        }
                                    </>
                                    
                                } 
                            </div>
                        </div> */}
                        <Menu as="div" className="relative inline-block text-center">
                            <div className='flex items-center'>
                                <MenuButton className='focus:outline-none'>
                                    <div className='relative h-10 w-10'>    
                                        {userProfilePicture &&
                                            <Image className='rounded-md'
                                                src={userProfilePicture}
                                                fill
                                                style={{objectFit: 'cover'}}
                                                placeholder="blur"
                                                blurDataURL={s3Static + "placeholder.png"}
                                                alt={userProfilePicture}
                                                sizes="(max-width: 768px) 20vw, 20vw"
                                            />
                                        }
                                    </div>
                                </MenuButton>
                            </div>
                            <Transition
                                as={Fragment}
                                enter="transition ease-out duration-200"
                                enterFrom="transform opacity-0 scale-y-0"
                                enterTo="transform opacity-100 scale-y-100"
                                leave="transition ease-in duration-200"
                                leaveFrom="transform opacity-100 scale-y-100"
                                leaveTo="transform opacity-0 scale-y-0"
                                >
                                <MenuItems className="absolute right-0 w-56 mt-1 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black/5 focus:outline-none">
                                    <div className="space-y-4 p-2">
                                        <MenuItem>
                                            <div onClick={() => changeRoute('/profile/' + handleName)} className='cursor-pointer'>
                                                <span className="py-1 rounded-md flex justify-center w-full bg-white text-orange-600 hover:bg-orange-400 focus:bg-orange-400 hover:text-white focus:text-white">                                        
                                                    Profile
                                                </span>
                                            </div>                                    
                                        </MenuItem>
                                        <MenuItem>
                                            <div onClick={() => changeRoute('/account')} className='cursor-pointer'>
                                                <span className="py-1 rounded-md flex justify-center w-full bg-white text-orange-600 hover:bg-orange-400 focus:bg-orange-400 hover:text-white focus:text-white">                                        
                                                    Account
                                                </span>
                                            </div>                                    
                                        </MenuItem>
                                        {userAccountType != "Employee" &&
                                        <>
                                            <MenuItem>
                                                <div onClick={() => changeRoute('/rewards')} className='cursor-pointer'>
                                                    <span className="py-1 rounded-md flex justify-center w-full bg-white text-orange-600 hover:bg-orange-400 focus:bg-orange-400 hover:text-white focus:text-white">                                        
                                                        Rewards
                                                    </span>
                                                </div>                                    
                                            </MenuItem>    
                                            <MenuItem>
                                                <div onClick={() => changeRoute('/account/referral')} className='cursor-pointer'>
                                                    <span className="py-1 rounded-md flex justify-center w-full bg-white text-orange-600 hover:bg-orange-400 focus:bg-orange-400 hover:text-white focus:text-white">                                        
                                                        Referral
                                                    </span>
                                                </div>                                    
                                            </MenuItem>  
                                        </>
                                        }  
                                        {(userAccountType === "Professional") &&   
                                            <MenuItem>
                                                <div onClick={() => changeRoute('/history')} className='cursor-pointer'>
                                                    <span className="py-1 rounded-md flex justify-center w-full bg-white text-orange-600 hover:bg-orange-400 focus:bg-orange-400 hover:text-white focus:text-white">                                        
                                                        {userServiceCategory === "Fitness Trainer" ? "Earnings" : "History"}
                                                    </span>
                                                </div>                                    
                                            </MenuItem>
                                        }
                                        {/* {(userAccountType === "Employee") &&                            
                                            <MenuItem>
                                                <div onClick={() => changeRoute('/history')} className='cursor-pointer'>
                                                    <span className="py-1 rounded-md flex justify-center w-full bg-white text-orange-600 hover:bg-orange-400 focus:bg-orange-400 hover:text-white focus:text-white">                                        
                                                        My Progress
                                                    </span>
                                                </div>                                    
                                            </MenuItem>
                                        } */}
                                    </div>
                                    <div className="px-1 py-3">
                                        <MenuItem>
                                            <button onClick={logoutUser} className="py-2 px-3 text-sm bg-white text-gray-400">                                        
                                                Logout
                                            </button>                            
                                        </MenuItem>                            
                                    </div>                                
                                </MenuItems>
                            </Transition>
                        </Menu>                       
                    </div>
                    <div className="flex items-center">
                        <div className="shrink-0 flex items-center">                        
                        {logoButton ? 
                            <div className='flex items-center cursor-pointer' onClick={() => reload()}>
                                <Image 
                                    height={47} 
                                    width={60} 
                                    src={s3Static + "logo.png"} 
                                    alt="StringsSG Logo"
                                    style={{'height': '47px', 'width': '60px'}}
                                />
                            </div>  
                            :
                            <button type="button" className="mr-5 p-2 text-orange-600 hover:text-orange-500" onClick={() => router.back()}>
                                <strong><FaChevronLeft className='text-xl'/></strong>
                            </button>
                        }
                        </div>
                        <div className="hidden md:block md:ml-6 absolute right-0">
                            <div className="flex space-x-4 items-center">
                                <div className='cursor-pointer' onClick={() => changeRoute('/home')}>
                                    <span className="px-2 py-2 text-orange-600 hover:text-orange-500 focus:text-orange-400">Home</span>
                                </div>
                                {userAccountType === "General" &&
                                    <div className='cursor-pointer' onClick={() => changeRoute('/history')}>
                                        <span className="px-2 py-2 text-orange-600 hover:text-orange-500 focus:text-orange-400">Orders</span>
                                    </div>
                                }
                                {(userAccountType === "Professional" || userAccountType === "Employee") &&
                                    <>
                                        {(businessType === "job" || businessType === "hybrid") ?
                                            <div className='cursor-pointer' onClick={() => changeRoute('/jobs')}>
                                                <span className="px-2 py-2 text-orange-600 hover:text-orange-500 focus:text-orange-400">Jobs</span>
                                            </div>
                                            :
                                            <div className='cursor-pointer' onClick={() => changeRoute('/history')}>
                                                <span className="px-2 py-2 text-orange-600 hover:text-orange-500 focus:text-orange-400">Orders</span>
                                            </div>
                                        }
                                    </>
                                }
                                {(userAccountType === "Professional" && (businessType === "job" || businessType === "hybrid")) &&                               
                                    <div className='cursor-pointer' onClick={() => changeRoute('/home/packages')}>
                                        <span className="px-2 py-2 text-orange-600 hover:text-orange-500 focus:text-orange-400">Packages</span>
                                    </div>
                                }
                                {userAccountType === "General" && 
                                    <div className='cursor-pointer' onClick={() => changeRoute('/account/my-packages')}>
                                        <span className="px-2 py-2 text-orange-600 hover:text-orange-500 focus:text-orange-400">Packages</span>
                                    </div>
                                }    
                                {(userAccountType === "Employee" && businessType === "hybrid") &&   
                                    <div className='cursor-pointer' onClick={() => changeRoute('/home/packages')}>
                                        <span className="px-2 py-2 text-orange-600 hover:text-orange-500 focus:text-orange-400">Packages</span>
                                    </div>     
                                }                       
                                {/* <div className='cursor-pointer' onClick={() => changeRoute('/home/buzz')}>
                                    <span className="px-2 py-2 text-orange-600 hover:text-orange-500 focus:text-orange-400">Buzz</span>
                                </div> */}
                                <div onClick={() => changeRoute('/notification')} className="relative inline-block text-center cursor-pointer">                                    
                                    <span className='flex items-center'> 
                                        <span className="pr-1 py-2 text-orange-600 hover:text-orange-500 focus:text-orange-400">     
                                            Notifications                                           
                                        </span>
                                        {notificationCount > 0 &&
                                            <span className='bg-red-600 text-white px-2 py-1 rounded-full text-xs'>
                                                {notificationCount > 20 ?
                                                    <>20+</>
                                                    :
                                                    <>{notificationCount}</>
                                                }                                                    
                                            </span>
                                        }    
                                        <span className='flex items-center text-orange-600 hover:text-orange-500 focus:text-orange-400'><FaCaretDown aria-hidden="true" /></span>                                        
                                    </span>
                                </div>
                                
                                <Menu as="div" className="relative inline-block text-center">
                                    <div>
                                    <MenuButton className="px-2 py-2 text-orange-600 hover:text-orange-500 focus:text-orange-400">
                                        <span className='flex items-center'>{userFirstName}<FaCaretDown aria-hidden="true" /></span>                                        
                                    </MenuButton>
                                    </div>
                                    <Transition
                                        as={Fragment}
                                        enter="transition ease-out duration-200"
                                        enterFrom="transform opacity-0 scale-y-0"
                                        enterTo="transform opacity-100 scale-y-100"
                                        leave="transition ease-in duration-200"
                                        leaveFrom="transform opacity-100 scale-y-100"
                                        leaveTo="transform opacity-0 scale-y-0"
                                        >
                                        <MenuItems className="absolute right-0 w-56 mt-1 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black/5 focus:outline-none">
                                            <div className="p-2">
                                                <MenuItem>
                                                    <div onClick={() => changeRoute('/account')} className="cursor-pointer">
                                                        <span className="py-1 rounded-md flex justify-center w-full bg-white text-orange-600 hover:bg-orange-400 focus:bg-orange-400 hover:text-white focus:text-white">                                        
                                                            Account
                                                        </span>
                                                    </div>                                    
                                                </MenuItem>
                                            </div>
                                            <div className="p-2">
                                                <MenuItem>
                                                    <div onClick={() => changeRoute('/profile/' + handleName)} className="cursor-pointer">
                                                        <span className="py-1 rounded-md flex justify-center w-full bg-white text-orange-600 hover:bg-orange-400 focus:bg-orange-400 hover:text-white focus:text-white">                                        
                                                            Profile
                                                        </span>
                                                    </div>                                    
                                                </MenuItem>
                                            </div>
                                            {userAccountType != "Employee" &&
                                                <>
                                                    <div className="p-2">
                                                        <MenuItem>
                                                            <div onClick={() => changeRoute('/rewards')} className="cursor-pointer">
                                                                <span className="py-1 rounded-md flex justify-center w-full bg-white text-orange-600 hover:bg-orange-400 focus:bg-orange-400 hover:text-white focus:text-white">                                        
                                                                    Rewards
                                                                </span>
                                                            </div>                                    
                                                        </MenuItem>
                                                    </div>
                                                    <div className="p-2">
                                                        <MenuItem>
                                                            <div onClick={() => changeRoute('/account/referral')} className="cursor-pointer">
                                                                <span className="py-1 rounded-md flex justify-center w-full bg-white text-orange-600 hover:bg-orange-400 focus:bg-orange-400 hover:text-white focus:text-white">                                        
                                                                    Referral
                                                                </span>
                                                            </div>                                    
                                                        </MenuItem>
                                                    </div>
                                                </>
                                            }
                                            {(userAccountType === "Professional") &&
                                                <div className="p-2">
                                                    <MenuItem>
                                                        <div onClick={() => changeRoute('/history')} className="cursor-pointer">
                                                            <span className="py-1 rounded-md flex justify-center w-full bg-white text-orange-600 hover:bg-orange-400 focus:bg-orange-400 hover:text-white focus:text-white">                                        
                                                               <span>
                                                                {userServiceCategory === "Fitness Trainer" ? "Earnings" : "History"}
                                                                </span>                                          
                                                            </span>
                                                        </div>                                    
                                                    </MenuItem>
                                                </div>
                                            }
                                            {/* {(userAccountType === "Employee") &&
                                                <div className="p-2">
                                                    <MenuItem>
                                                        <div onClick={() => changeRoute('/history')} className="cursor-pointer">
                                                            <span className="py-1 rounded-md flex justify-center w-full bg-white text-orange-600 hover:bg-orange-400 focus:bg-orange-400 hover:text-white focus:text-white">                                        
                                                               <span>My Progress</span>                                          
                                                            </span>
                                                        </div>                                    
                                                    </MenuItem>
                                                </div>
                                            } */}
                                            <div className="px-1 py-3">
                                                <MenuItem>
                                                    <button onClick={logoutUser} className="py-2 px-3 text-sm bg-white text-gray-400">                                        
                                                        Logout
                                                    </button>                            
                                                </MenuItem>                            
                                            </div>                                
                                        </MenuItems>
                                    </Transition>
                                </Menu>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
        {isLoading &&
            <LoadingCover/>
        }
        {isSystemError && <SystemError errorContent={errorContent} setIsSystemError={setIsSystemError}/>}
      </section>
  )
}
